import defaultEventDispatcher from './event_dispatcher/default_dispatcher.browser';
import { getOpaqueBatchEventProcessor, getPrefixEventStore, wrapEventProcessor, getForwardingEventProcessor, } from './event_processor_factory';
import { FAILED_EVENT_RETRY_INTERVAL } from './event_processor_factory';
import { AsyncStorageCache } from '../utils/cache/async_storage_cache.react_native';
import { ReactNativeNetInfoEventProcessor } from './batch_event_processor.react_native';
import { DEFAULT_MAX_EVENTS_IN_STORE, EventStore } from './event_store';
export const DEFAULT_EVENT_BATCH_SIZE = 10;
export const DEFAULT_EVENT_FLUSH_INTERVAL = 1000;
export const EVENT_MAX_RETRIES_REACT_NATIVE = 2;
export const createForwardingEventProcessor = (eventDispatcher = defaultEventDispatcher) => {
    return wrapEventProcessor(getForwardingEventProcessor(eventDispatcher));
};
export const createBatchEventProcessor = (options = {}) => {
    var _a;
    const eventStore = options.eventStore ? getPrefixEventStore(options.eventStore) : new EventStore({
        store: new AsyncStorageCache(),
        maxSize: options.batchSize ? Math.max(options.batchSize * 2, DEFAULT_MAX_EVENTS_IN_STORE)
            : DEFAULT_MAX_EVENTS_IN_STORE,
        ttl: options.storeTtl,
    });
    return getOpaqueBatchEventProcessor({
        eventDispatcher: options.eventDispatcher || defaultEventDispatcher,
        closingEventDispatcher: options.closingEventDispatcher,
        flushInterval: options.flushInterval,
        batchSize: options.batchSize,
        defaultFlushInterval: DEFAULT_EVENT_FLUSH_INTERVAL,
        defaultBatchSize: DEFAULT_EVENT_BATCH_SIZE,
        retryOptions: {
            maxRetries: (_a = options.maxRetries) !== null && _a !== void 0 ? _a : EVENT_MAX_RETRIES_REACT_NATIVE,
        },
        failedEventRetryInterval: FAILED_EVENT_RETRY_INTERVAL,
        eventStore,
    }, ReactNativeNetInfoEventProcessor);
};
export const __platforms = ['react_native'];
//# sourceMappingURL=event_processor_factory.react_native.js.map